import styles from './Socials.module.scss';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

type SocialRegisterProps = {
  type?: 'phone' | 'email';
};

const SocialRegister: React.FC<SocialRegisterProps> = ({ type }) => {
  const { query } = useRouter();

  return (
    <div className={styles.buttonGroup}>
      {type === 'email' ? (
        <div className={styles.optionButton}>
          <Link
            href={{
              pathname: '/register',
              query: {
                ...query,
                type: 'email'
              }
            }}
            className={styles.phone}
            data-test="btn-email-login"
          >
            <img src="/img/icons/envelope.svg" />
          </Link>
        </div>
      ) : (
        <div className={styles.optionButton}>
          <Link
            href={{
              pathname: '/register',
              query: {
                ...query,
                type: 'phone'
              }
            }}
            className={styles.phone}
            data-test="img-phone"
          >
            <img src="/img/icons/phone.svg" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default SocialRegister;
